import { render } from "./BuyPage.vue?vue&type=template&id=1ddc9e69&scoped=true"
import script from "./BuyPage.vue?vue&type=script&lang=js"
export * from "./BuyPage.vue?vue&type=script&lang=js"

import "./BuyPage.vue?vue&type=style&index=0&id=1ddc9e69&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ddc9e69"]])

export default __exports__